// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.renderer-shell {
  display: grid;
  gap: 1.5rem;
}

.renderer-header {
  padding: 1.25rem 1.5rem;
  background: #f4f7fa;
  border: 1px solid #dce4eb;
  border-left: 4px solid #0073e6;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.renderer-header h2 {
  margin: 0;
  font-size: 1.6rem;
  line-height: 1.2;
  font-weight: 700;
  color: #1a2a38;
  letter-spacing: -0.01em;
}
.renderer-header p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #56636f;
}

.import-panel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem 0.9rem;
  border: 1px solid #d4dde2;
  border-radius: 8px;
  background: #fff;
  padding: 0.85rem;
}
.import-panel input[type=file] {
  display: none;
}
.import-panel .upload-btn {
  background: #0f6075;
  color: #fff;
  border-radius: 4px;
  min-height: 2.55rem;
  padding: 0.5rem 0.85rem;
  font-size: 0.9rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.import-panel .selected-file,
.import-panel .state {
  font-size: 0.88rem;
  line-height: 1.35;
}
.import-panel .state.success {
  color: #1f7a1f;
}
.import-panel .state.error {
  color: #b62727;
}

.runtime-form {
  display: grid;
  gap: 1.1rem;
}

.section-card,
.table-card {
  border: 1px solid #d4dde2;
  border-radius: 8px;
  padding: 1rem 1rem 1.1rem;
  background: #fff;
}
.section-card h3,
.table-card h3 {
  margin: 0;
  font-size: 1.06rem;
  line-height: 1.3;
  font-weight: 700;
}
.section-card p,
.table-card p {
  margin: 0.45rem 0 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #555;
}

.field-grid {
  display: grid;
  gap: 1rem;
}

.field-wrap {
  display: grid;
  gap: 0.45rem;
}
.field-wrap label {
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.3;
}
.field-wrap label .required-mark {
  color: #b62727;
  margin-left: 0.18rem;
}
.field-wrap input,
.field-wrap select {
  border: 1px solid #c2ccd2;
  border-radius: 4px;
  min-height: 2.75rem;
  padding: 0.55rem 0.65rem;
  font-size: 0.95rem;
  line-height: 1.35;
  width: 100%;
  box-sizing: border-box;
}
.field-wrap input[type=checkbox] {
  min-height: 1.05rem;
  width: 1.05rem;
  height: 1.05rem;
  margin-top: 0.2rem;
  justify-self: start;
}

.errors {
  color: #b62727;
  font-size: 0.8rem;
  line-height: 1.45;
}

.table-card table {
  width: 100%;
  border-collapse: collapse;
}
.table-card table th,
.table-card table td {
  border: 1px solid #d4dde2;
  padding: 0.6rem;
  vertical-align: top;
  line-height: 1.4;
}
.table-card table th {
  background: #f4f8fa;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
}

.submit-btn {
  justify-self: start;
  border: 0;
  border-radius: 4px;
  background: #0f6075;
  color: #fff;
  min-height: 2.7rem;
  padding: 0.6rem 1rem;
  font-size: 0.94rem;
  font-weight: 600;
  cursor: pointer;
}

.submit-state {
  margin: 0.1rem 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #334;
}

.results-panel {
  border: 1px solid #cfe3e7;
  background: #f2fbfc;
  border-radius: 6px;
  padding: 0.9rem 1rem;
}
.results-panel h3 {
  margin: 0 0 0.6rem;
  font-size: 1rem;
}
.results-panel dl {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.35rem 1rem;
  margin: 0;
}
.results-panel dt {
  font-weight: 600;
  color: #333;
  line-height: 1.35;
}
.results-panel dd {
  margin: 0;
  color: #111;
  line-height: 1.35;
}

@media (max-width: 980px) {
  .field-grid {
    grid-template-columns: 1fr !important;
  }
}
@media (max-width: 720px) {
  .renderer-shell {
    gap: 1rem;
  }
  .renderer-header h2 {
    font-size: 1.35rem;
  }
  .import-panel,
  .section-card,
  .table-card,
  .results-panel {
    padding: 0.8rem;
  }
  .table-card {
    overflow: auto;
  }
  .table-card table {
    min-width: 560px;
  }
  .submit-btn {
    width: 100%;
    justify-self: stretch;
  }
  .results-panel dl {
    grid-template-columns: 1fr;
    gap: 0.15rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/dynamic-forms/components/dynamic-form-renderer/dynamic-form-renderer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACF;AACE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AACJ;AAEE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AADF;AAGE;EACE,aAAA;AADJ;AAIE;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AAFJ;AAKE;;EAEE,kBAAA;EACA,iBAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,cAAA;AALJ;;AASA;EACE,aAAA;EACA,WAAA;AANF;;AASA;;EAEE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AANF;AAQE;;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AALJ;AAQE;;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AALJ;;AASA;EACE,aAAA;EACA,SAAA;AANF;;AASA;EACE,aAAA;EACA,YAAA;AANF;AAQE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AANJ;AAQI;EACE,cAAA;EACA,oBAAA;AANN;AAUE;;EAEE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;AARJ;AAWE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AATJ;;AAaA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,WAAA;EACA,yBAAA;AAVF;AAYE;;EAEE,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAXJ;;AAeA;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAZF;;AAeA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAZF;;AAeA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAZF;AAcE;EACE,kBAAA;EACA,eAAA;AAZJ;AAeE;EACE,aAAA;EACA,sCAAA;EACA,iBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,SAAA;EACA,WAAA;EACA,iBAAA;AAfJ;;AAmBA;EACE;IACE,qCAAA;EAhBF;AACF;AAmBA;EACE;IACE,SAAA;EAjBF;EAoBA;IACE,kBAAA;EAlBF;EAqBA;;;;IAIE,eAAA;EAnBF;EAsBA;IACE,cAAA;EApBF;EAuBA;IACE,gBAAA;EArBF;EAwBA;IACE,WAAA;IACA,qBAAA;EAtBF;EAyBA;IACE,0BAAA;IACA,YAAA;EAvBF;AACF","sourcesContent":[".renderer-shell {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.renderer-header {\n  padding: 1.25rem 1.5rem;\n  background: #f4f7fa;\n  border: 1px solid #dce4eb;\n  border-left: 4px solid #0073e6;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n\n  h2 {\n    margin: 0;\n    font-size: 1.6rem;\n    line-height: 1.2;\n    font-weight: 700;\n    color: #1a2a38;\n    letter-spacing: -0.01em;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9rem;\n    line-height: 1.5;\n    color: #56636f;\n  }\n}\n\n.import-panel {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem 0.9rem;\n  border: 1px solid #d4dde2;\n  border-radius: 8px;\n  background: #fff;\n  padding: 0.85rem;\n\n  input[type='file'] {\n    display: none;\n  }\n\n  .upload-btn {\n    background: #0f6075;\n    color: #fff;\n    border-radius: 4px;\n    min-height: 2.55rem;\n    padding: 0.5rem 0.85rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .selected-file,\n  .state {\n    font-size: 0.88rem;\n    line-height: 1.35;\n  }\n\n  .state.success {\n    color: #1f7a1f;\n  }\n\n  .state.error {\n    color: #b62727;\n  }\n}\n\n.runtime-form {\n  display: grid;\n  gap: 1.1rem;\n}\n\n.section-card,\n.table-card {\n  border: 1px solid #d4dde2;\n  border-radius: 8px;\n  padding: 1rem 1rem 1.1rem;\n  background: #fff;\n\n  h3 {\n    margin: 0;\n    font-size: 1.06rem;\n    line-height: 1.3;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0.45rem 0 0;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    color: #555;\n  }\n}\n\n.field-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.field-wrap {\n  display: grid;\n  gap: 0.45rem;\n\n  label {\n    font-size: 0.88rem;\n    font-weight: 600;\n    line-height: 1.3;\n\n    .required-mark {\n      color: #b62727;\n      margin-left: 0.18rem;\n    }\n  }\n\n  input,\n  select {\n    border: 1px solid #c2ccd2;\n    border-radius: 4px;\n    min-height: 2.75rem;\n    padding: 0.55rem 0.65rem;\n    font-size: 0.95rem;\n    line-height: 1.35;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  input[type='checkbox'] {\n    min-height: 1.05rem;\n    width: 1.05rem;\n    height: 1.05rem;\n    margin-top: 0.2rem;\n    justify-self: start;\n  }\n}\n\n.errors {\n  color: #b62727;\n  font-size: 0.8rem;\n  line-height: 1.45;\n}\n\n.table-card table {\n  width: 100%;\n  border-collapse: collapse;\n\n  th,\n  td {\n    border: 1px solid #d4dde2;\n    padding: 0.6rem;\n    vertical-align: top;\n    line-height: 1.4;\n  }\n\n  th {\n    background: #f4f8fa;\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n}\n\n.submit-btn {\n  justify-self: start;\n  border: 0;\n  border-radius: 4px;\n  background: #0f6075;\n  color: #fff;\n  min-height: 2.7rem;\n  padding: 0.6rem 1rem;\n  font-size: 0.94rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.submit-state {\n  margin: 0.1rem 0 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: #334;\n}\n\n.results-panel {\n  border: 1px solid #cfe3e7;\n  background: #f2fbfc;\n  border-radius: 6px;\n  padding: 0.9rem 1rem;\n\n  h3 {\n    margin: 0 0 0.6rem;\n    font-size: 1rem;\n  }\n\n  dl {\n    display: grid;\n    grid-template-columns: max-content 1fr;\n    gap: 0.35rem 1rem;\n    margin: 0;\n  }\n\n  dt {\n    font-weight: 600;\n    color: #333;\n    line-height: 1.35;\n  }\n\n  dd {\n    margin: 0;\n    color: #111;\n    line-height: 1.35;\n  }\n}\n\n@media (max-width: 980px) {\n  .field-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n@media (max-width: 720px) {\n  .renderer-shell {\n    gap: 1rem;\n  }\n\n  .renderer-header h2 {\n    font-size: 1.35rem;\n  }\n\n  .import-panel,\n  .section-card,\n  .table-card,\n  .results-panel {\n    padding: 0.8rem;\n  }\n\n  .table-card {\n    overflow: auto;\n  }\n\n  .table-card table {\n    min-width: 560px;\n  }\n\n  .submit-btn {\n    width: 100%;\n    justify-self: stretch;\n  }\n\n  .results-panel dl {\n    grid-template-columns: 1fr;\n    gap: 0.15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
